"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const elements_1 = require("@src/components/elements");
const react_intl_1 = require("react-intl");
const styled_components_1 = __importDefault(require("styled-components"));
const styled_breakpoints_1 = require("styled-breakpoints");
const StyledCookieConsent = styled_components_1.default.div `
	color: ${props => props.theme.color.gray1};
	z-index: ${props => props.theme.zIndex.cookieConsent};
	bottom: 0;
	left: 0;
	right: 0;
	position: fixed;
	width: 100%;
	margin: 0 auto;
	text-align: center;
	font-size: 1em;

	${(0, styled_breakpoints_1.up)('md')} {
		width: 50%;
	}
`;
const HolderInner = styled_components_1.default.div `
	color: ${props => props.theme.color.gray1};
	background: ${props => props.theme.color.brand4};
	z-index: ${props => props.theme.zIndex.cookieConsent};
	padding: 1.5em 1.5em 1em;
	width: 100%;
	border-radius: 4px 4px 0 0;
	box-shadow: 0 15px 35px rgb(50 50 77 / 20%), 0 5px 30px rgb(0 0 0 / 15%);
`;
const StyledLink = (0, styled_components_1.default)(elements_1.Link) `
	&,
	&:link,
	&:visited,
	&:focus {
		color: ${props => props.theme.color.white};
		text-decoration: underline;
	}
`;
const CookieConsent = ({ onAgree }) => {
    return ((0, jsx_runtime_1.jsx)(StyledCookieConsent, { children: (0, jsx_runtime_1.jsxs)(HolderInner, { children: [(0, jsx_runtime_1.jsxs)("p", { children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "global.cookie_consent.cookie_usage" }), ' ', (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "global.cookie_consent.more_info", values: {
                                Link: chunks => (0, jsx_runtime_1.jsx)(StyledLink, { to: "/ochrana-osobnych-udajov", children: chunks }),
                            } })] }), (0, jsx_runtime_1.jsx)(elements_1.Button, { color: "warning", onClick: onAgree, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "global.cookie_consent.agree" }) })] }) }));
};
exports.default = CookieConsent;
